import { SvgIcon, type SvgIconProps } from "@mui/material"
import React from "react"

interface CustomIconProps extends SvgIconProps {
    svgContent: React.ReactNode
}

/**
 * Componente genérico para crear iconos personalizados
 * @param svgContent - Contenido SVG a renderizar dentro del icono
 * @param props - Propiedades adicionales para el SvgIcon
 */
export const CustomIcon = ({ svgContent, ...props }: CustomIconProps) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        {svgContent}
    </SvgIcon>
)
